"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseSearchOptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bs_1 = require("react-icons/bs");
const Button_1 = __importDefault(require("../../elements/Button"));
const CounterLabel_1 = require("../../elements/CounterLabel");
const Input_1 = __importDefault(require("../../elements/Input"));
const PreferencesButton_1 = require("../../elements/PreferencesButton");
const Select_1 = __importDefault(require("../../elements/Select"));
const PanelHeader_1 = __importDefault(require("../header/PanelHeader"));
const useToolsFunctions_1 = __importDefault(require("../../hooks/useToolsFunctions"));
const ToolTypes_1 = require("../../toolbar/ToolTypes");
const DefaultPanelHeader_1 = require("../header/DefaultPanelHeader");
const fa_1 = require("react-icons/fa");
const io5_1 = require("react-icons/io5");
const ToggleButton_1 = __importDefault(require("../../elements/ToggleButton"));
function DatabaseSearchOptions({ databases, defaultDatabase, keywords, result, selectedTool, idCode, total, onKeywordsChange, onSettingClick, onStructureClick, onDatabaseChange, }) {
    const { handleChangeOption } = (0, useToolsFunctions_1.default)();
    function enableFilterHandler(flag) {
        const tool = !flag ? ToolTypes_1.options.zoom.id : ToolTypes_1.options.databaseRangesSelection.id;
        handleChangeOption(tool);
    }
    function handleSearch(input) {
        if (typeof input === 'string' || input === -1) {
            const solvent = String(input);
            onKeywordsChange({ solvent });
        }
        else {
            onKeywordsChange({
                searchKeywords: input.target.value,
            });
        }
    }
    function clearHandler() {
        onKeywordsChange({ searchKeywords: '' });
    }
    return ((0, jsx_runtime_1.jsxs)(PanelHeader_1.default, { style: { flexDirection: 'column', alignItems: 'normal' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingBottom: '2px',
                }, children: [(0, jsx_runtime_1.jsx)(Select_1.default, { style: { flex: 6 }, items: databases, itemTextField: "label", itemValueField: "key", onChange: onDatabaseChange, placeholder: "Select database", defaultValue: defaultDatabase }), (0, jsx_runtime_1.jsx)(Select_1.default, { style: { flex: 4, margin: '0px 5px' }, items: result.solvents, placeholder: "Solvent", onChange: handleSearch, value: keywords.solvent }), (0, jsx_runtime_1.jsxs)("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            flex: 2,
                            justifyContent: 'flex-end',
                        }, children: [(0, jsx_runtime_1.jsx)(CounterLabel_1.CounterLabel, { children: (0, DefaultPanelHeader_1.createFilterLabel)(total || 0, result.data.length) }), (0, jsx_runtime_1.jsx)(PreferencesButton_1.PreferencesButton, { onClick: onSettingClick })] })] }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(ToggleButton_1.default, { defaultValue: selectedTool === ToolTypes_1.options.databaseRangesSelection.id, popupTitle: "Filter by select ranges", popupPlacement: "right", onClick: enableFilterHandler, children: (0, jsx_runtime_1.jsx)(fa_1.FaICursor, { style: {
                                pointerEvents: 'none',
                                fontSize: '12px',
                                transform: 'rotate(90deg)',
                            } }) }, `${selectedTool}`), (0, jsx_runtime_1.jsx)(Input_1.default, { value: keywords.searchKeywords, renderIcon: () => (0, jsx_runtime_1.jsx)(io5_1.IoSearchOutline, {}), style: { inputWrapper: { margin: '0 5px', flex: 1 } }, className: "search-input", type: "text", debounceTime: 250, placeholder: "Search for parameter...", onChange: handleSearch, onClear: clearHandler, canClear: true }), (0, jsx_runtime_1.jsx)(Button_1.default.Done, { fill: "clear", onClick: onStructureClick, style: { padding: '5px' }, children: !idCode ? ((0, jsx_runtime_1.jsx)(bs_1.BsHexagon, { style: {
                                fontSize: '12px',
                            } })) : ((0, jsx_runtime_1.jsx)(bs_1.BsHexagonFill, { style: {
                                fontSize: '12px',
                            } })) })] })] }));
}
exports.DatabaseSearchOptions = DatabaseSearchOptions;
